export default {
  buttons: { done: 'Gata' },
  title: 'Locație',
};
